module.exports = __webpack_public_path__ + "media/images/safari-pinned-tab-60a403231500926639bba9cbde02ce90.svg";